var requestIdCounter = 0;

function JsonRequest(url, data, override, type) {
  this.url = url;
  this.data = data;
  this._cache = false;
  this._context = null;
  this._successFunction = null; // API response success
  this._afterSuccessDialogFunction = null; // After API response success
  this._errorFunction = null; // API response error
  this._afterErrorDialogFunction = null; // After API response error
  this._failureFunction = null; // API connection error
  this.getXHR = false;
  this.xhr = null;
  this._useRequestId = false;
  this._hasLoader = false;
  this.loading = new Loading();
  this.override = override || false;
  this._completeFunction = null;
  this.contentType = 'application/json; charset=UTF-8';
  this.processData = true;
  this._dontHideLoaderOnSuccess = false;
  this.noApiErrorPopup = false;
  this.type = type || 'POST';

  this.success = function(f) {
    this._successFunction = f;
    return this;
  };

  this.error = function(f) {
    this._errorFunction = f;
    return this;
  };

  this.afterSuccessDialogFunction = function(f) {
    this._afterSuccessDialogFunction = f;
    return this;
  };

  this.afterErrorDialogFunction = function(f) {
    this._afterErrorDialogFunction = f;
    return this;
  };

  this.failure = function(f) {
    this._failureFunction = f;
    return this;
  };

  this.complete = function(f) {
    this._completeFunction = f;
    return this;
  }

  this.useRequestId = function(b) {
    this._useRequestId = b;
    return this;
  };

  this.cache = function(b) {
    this._cache = b;
    return this;
  }

  this.context = function(c) {
    this._context = c;
    return this;
  };

  this.setContentType = function(v) {
    this.contentType = v;
    return this;
  };

  this.setProcessData = function(v) {
    this.processData = v;
    return this;
  };

  this.dontHideLoaderOnSuccess = function(b) {
    this._dontHideLoaderOnSuccess = b;
    return this;
  };

  this.call = function() {
    this._hasLoader = true;
    this.showLoader();
    this.send(false);
  };

  this.send = function(ignoreWarning) {
    this.data['ignoreWarning'] = ignoreWarning;
    this.data['device'] = 'D';
    var accountIdParam = getAccountIdParam();
    if (accountIdParam) {
      this.data['accountId'] = accountIdParam;
    }

    if (this._useRequestId) {
      this.data['requestId'] = ++requestIdCounter;
    }

    var formatData = this.type === 'POST' || this.type === 'PUT' || this.type === 'DELETE' ? JSON.stringify(this.data) : this.data;

    var xhr = $.ajax({
      cache: this._cache,
      url: this.url,
      type: this.type,
      dataType: 'json',
      data: formatData,
      context: this,
      contentType: this.contentType,
      processData: this.processData,
      xhrFields: {
        withCredentials: true
      },
      beforeSend: function(req) {
        req.setRequestHeader("requestId", uuidv4());
      },
      success: function(json) {
        var _this = this;
        var _json = json;

        if (_this._useRequestId) {
          if (requestIdCounter != json.requestId) {
            if (_this._hasLoader) {
              _this.hideLoader();
            }
            console.log("requestId mismatch (" + _this.url + "): " + requestIdCounter + " vs " + json.requestId);
            return;
          }
        }

        if (_this._hasLoader && !_this._dontHideLoaderOnSuccess) {
          _this.hideLoader();
        }

        // Warning
        if (json.warning) {
          if (_this._hasLoader) {
            _this.hideLoader();
          }
        }

        // for pop-ups
        if (json.title && json.title.length > 0 && json.message && json.message.length > 0) {

          if (this.override) {
            if (_this._successFunction != null) {
              _this._successFunction(json, _this._context);
            }
            return;
          }

          var options = {
            title: json.title,
            message: json.message
          };

          if (this._afterSuccessDialogFunction != null) {
            options.okCallback = function() {
              _this._afterSuccessDialogFunction();
            }
          }
          var popup = new Popup(options);
          popup.render();
        }

        if (_this._successFunction != null) {
          _this._successFunction(json, _this._context);
        }

      },
      error: function(json) {
        var errorBody = json.responseJSON;
        var httpStatus = json.status;
        var _this = this;
        var genericMessage = 'We regret that this page could not load. Please try again. If the problem persists, please <a href="/contact">contact us</a>.';
        var genericTitle = 'Connection Timeout';

        if (_this._hasLoader) {
          _this.hideLoader();
        }

        // Error
        if (httpStatus === 400) {
          if (_this._hasLoader) {
            _this.hideLoader();
          }

          // Go to due diligence extra page
          if (errorBody && typeof errorBody.pendingDueDiligenceHighRisk !== 'undefined' && errorBody.pendingDueDiligenceHighRisk) {
            var options = {
              title: 'BullionStar Account Verification',
              message: getDueDiligencePopupString(),
              okCallback: function() {
                window.location.href = '/duediligence-extra';
              },
              cancel: true
            };
            var popup = new Popup(options);
            popup.render();

            return;
          }

          // Show due diligence popup
          if (errorBody && typeof errorBody.pendingDueDiligence !== 'undefined' && errorBody.pendingDueDiligence) {
            var options = {
              title: 'BullionStar Account Verification',
              message: getDueDiligencePopupString(),
              okCallback: function() {
                window.location.href = '/duediligence';
              },
              cancel: true
            };
            var popup = new Popup(options);
            popup.render();

            return;
          }

          // Override popup showing error message
          // Used in order confirmation page
          if (errorBody && 'accessAllowed' in errorBody && !errorBody.accessAllowed) {
            if (_this._errorFunction != null) {
              _this._errorFunction(errorBody);
            }

            return;
          }

          if (errorBody && errorBody.title && errorBody.title.length > 0 && errorBody.message && errorBody.message.length > 0) {
            if (_this._errorFunction != null) {
              _this._errorFunction(errorBody);
              return;
            }
            if (_this._afterErrorDialogFunction != null) {
              var options = {
                title: errorBody.title,
                message: errorBody.message,
                okCallback: function() {
                  _this._afterErrorDialogFunction(errorBody);
                }
              };
              var popup = new Popup(options);
              popup.render();
            } else {
              var popup = new Popup({
                title: errorBody.title,
                message: errorBody.message
              });
              popup.render();
            }
          }

          if (_this._errorFunction != null) {
            _this._errorFunction(errorBody);
          }
        } else if (httpStatus === 401) {
          // Authentication Required
          if (_this._hasLoader) {
            _this.hideLoader();
          }

          var login = new PopupLogin({
            redirectOnClose: true
          });
          login.render();

          // Override popup showing error message
          // Used in order confirmation page
          if ('accessAllowed' in errorBody && errorBody.accessAllowed) {
            if (_this._errorFunction != null) {
              _this._errorFunction(errorBody);
            }
          }
          return;

        } else if (httpStatus === 403) {
          window.location.href = '/login?source=403';
          return;
        } else if (httpStatus === 500) {
          // var popup = new Popup({ title: genericTitle, message: genericMessage });
          // popup.render();
          return;
        }

        if (json.statusText === 'abort') {
          console.log('Don\'t freak out. User Aborted!');
          return;
        }

        console.log('API connection error');

        if (_this._failureFunction != null) {
          _this._failureFunction();
        } else {
          // if(!_this.noApiErrorPopup) {
          //   var popup = new Popup({ title: genericTitle, message: genericMessage });
          //   popup.render();
          // }
        }
      },
      complete: function(json) {
        var _this = this;
        if (_this._completeFunction != null) {
          _this._completeFunction(json);
        }
      }
    });

    if (this.getXHR) {
      this.xhr = xhr;
    }
  };

  this.showLoader = function() {
    this.loading.render();
  };

  this.hideLoader = function() {
    this.loading.close();
  };
}